import { motion } from "framer-motion";
import { CheckCircle, DollarSign, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

export const DonationSuccessView = ({ isPolling, paymentStatus, t }) => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full text-center"
      >
        {isPolling && (
          <>
            <Loader2 className="w-16 h-16 text-warm-600 mx-auto mb-6 animate-spin" />
            <h2 className="text-2xl font-semibold text-gray-900 mb-2" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>
              {t.processing}
            </h2>
            <p className="text-gray-600">{t.processingNote}</p>
          </>
        )}
        {paymentStatus === "success" && (
          <>
            <div className="w-20 h-20 bg-warm-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-warm-700" />
            </div>
            <h2 className="text-3xl font-semibold text-gray-900 mb-4" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>
              {t.thankYou}
            </h2>
            <p className="text-gray-600 mb-8">{t.thankYouNote}</p>
            <a href="/donate">
              <Button className="bg-warm-700 hover:bg-warm-800 text-white rounded-full px-8">
                {t.donateAgain}
              </Button>
            </a>
          </>
        )}
        {(paymentStatus === "error" || paymentStatus === "timeout" || paymentStatus === "expired") && (
          <>
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <DollarSign className="w-10 h-10 text-red-600" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>
              {t.paymentIssue}
            </h2>
            <p className="text-gray-600 mb-8">{t.paymentIssueNote}</p>
            <a href="/donate">
              <Button className="bg-warm-700 hover:bg-warm-800 text-white rounded-full px-8">
                {t.tryAgain}
              </Button>
            </a>
          </>
        )}
      </motion.div>
    </div>
  );
};
